import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { AuxiliaryDataModule } from '@vendasta/auxiliary-data-components';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyButtonLoadingIndicatorModule } from '@vendasta/galaxy/button-loading-indicator';
import { GalaxyCheckboxModule } from '@vendasta/galaxy/checkbox';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { VaFilterModule, VaTableModule } from '@vendasta/uikit';
import { VFormModule } from '@vendasta/vform';
import { ConfirmationDialogComponent } from '../common/confirmation-dialog.component';
import { TertiaryDropdownButtonModule } from '../common/tertiary-dropdown-button/tertiary-dropdown-button.module';
import { TeamMemberService } from '../manage-team/team-member.service';
import { VbcHostService } from '../vbc/vbc.host.service';
import { ManageUsersComponent } from './manage-users.component';
import { ResendWelcomeEmailDialogModule } from './resend-welcome-email-dialog/resend-welcome-email-dialog.module';
import { ResetPasswordService } from './reset-password.service';
import { UserBulkActionsService } from './user-bulk-actions/user-bulk-actions.service';
import { UserProfilePageComponent } from './user-profile-page/user-profile-page.component';
import { CreateUserFormComponent } from './user/create-user-form.component';
import { BusinessUserCreateComponent } from './user/create.component';
import { BusinessUserEditComponent } from './user/edit.component';

@NgModule({
  imports: [
    ConfirmationDialogComponent,
    AuxiliaryDataModule,
    CommonModule,
    CreateUserFormComponent,
    GalaxyButtonLoadingIndicatorModule,
    GalaxyCheckboxModule,
    GalaxyEmptyStateModule,
    GalaxyFormFieldModule,
    GalaxyInputModule,
    GalaxyLoadingSpinnerModule,
    GalaxyPageModule,
    GalaxyWrapModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule,
    ReactiveFormsModule,
    ResendWelcomeEmailDialogModule,
    RouterModule,
    TertiaryDropdownButtonModule,
    TranslateModule,
    VaTableModule,
    VFormModule,
    GalaxyBadgeModule,
    VaFilterModule,
  ],
  declarations: [
    ManageUsersComponent,
    UserProfilePageComponent,
    BusinessUserCreateComponent,
    BusinessUserEditComponent,
  ],
  providers: [UserBulkActionsService, VbcHostService, ResetPasswordService, TranslateService, TeamMemberService],
  exports: [UserProfilePageComponent],
})
export class UsersModule {}
